export default __webpack_public_path__ + "static/littleme-3399ae5098fa1a8e351b0510b23049ac.jpg";